module.exports = __webpack_public_path__ + "static/media/subway.d5320554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/subway.png
// module id = 265
// module chunks = 0